<template>
  <div class="px-4 py-5 sm:px-6">
    <slot />
  </div>
</template>
